import React from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../components/CustomButton";

export default function PatientStart() {
  const navigate = useNavigate();

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "calc(100vh - 3rem)",
          background: "#f4f4f4",
        }}
      >
        <div
          style={{
            background: "#fff",
            padding: "2rem",
            borderRadius: "4px",
            width: "300px",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
            textAlign: "center",
          }}
        >
          <h3 style={{ marginTop: 0, marginBottom: "1.5rem" }}>何をしますか？</h3>
          <CustomButton
            kind="primary"
            fullWidth style={{ marginBottom: "1rem" }}
            onClick={() => navigate("/pre-interview")}
          >
            AI問診を始める
          </CustomButton>
          <CustomButton
            kind="secondary"
            fullWidth
            onClick={() => navigate("/summary")}
          >
            ダッシュボードへ
          </CustomButton>
        </div>
      </div>
    </>
  );
}
